import styled, { withTheme, DefaultTheme } from 'styled-components';
import { Row, Col } from 'antd';

import { IOffice } from '../../common/model/office.model';
import { OfficeCard } from '.';

type Props = {
  offices: IOffice[];
  className?: string;
  theme: DefaultTheme;
};

const OfficesRowContainer: React.FC<Props> = ({
  offices,
  className,
  theme,
}) => {
  return (
    <div className={className}>
      <Row gutter={[32, 32]}>
        {offices.map((office) => (
          <Col key={office.id} xs={24} md={12} xxl={8}>
            <OfficeCard office={office} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default withTheme<typeof OfficesRowContainer>(styled(
  OfficesRowContainer
)`
  padding-left: ${(props) => props.theme.grid.getGridColumns(2, 1)};
  padding-right: ${(props) => props.theme.grid.getGridColumns(2, 1)};
  padding-top: 32px;
  padding-bottom: 32px;
`);
